module.exports = __webpack_public_path__ + "static/media/AWS-EKS.6f8e73f2.png";